import { paletteLight } from "./lightTheme";
import { paletteDark } from "./darkTheme";

export const palette = { paletteDark, paletteLight };
